var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.hasNextGroups || _vm.hasActiveGroup || _vm.hasOldGroups
    ? _c("div", { staticClass: "actual-groups-of-one-type" }, [
        _c("h5", {
          staticClass: "actual-groups-header",
          domProps: { textContent: _vm._s(_vm.courseType.name) }
        }),
        _vm._v(" "),
        _vm.showNextGroups && _vm.hasNextGroups
          ? _c(
              "ul",
              _vm._l(_vm.nextGroups, function(nextGroup) {
                return _c("li", { key: nextGroup.id }, [
                  _c(
                    "a",
                    {
                      staticClass: "text-dark",
                      attrs: { href: "javascript://" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("select-course-group", nextGroup)
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass:
                          "fa fa-arrow-circle-o-up fa-lg text-secondary",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(nextGroup.getDisplayDate()) +
                          "\n            "
                      )
                    ]
                  )
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasActiveGroup
          ? _c("ul", [
              _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "text-dark",
                    attrs: { href: "javascript://" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("select-course-group", _vm.activeGroup)
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass:
                        "fa fa-arrow-circle-o-right fa-lg text-success",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.activeGroup.getDisplayDate()) +
                        "\n            "
                    )
                  ]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasOldGroups
          ? _c(
              "ul",
              _vm._l(_vm.oldGroups, function(oldGroup) {
                return _c("li", { key: oldGroup.id }, [
                  _c(
                    "a",
                    {
                      staticClass: "text-dark",
                      attrs: { href: "javascript://" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("select-course-group", oldGroup)
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass:
                          "fa fa-arrow-circle-o-down fa-lg text-danger",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(oldGroup.getDisplayDate()) +
                          "\n            "
                      )
                    ]
                  )
                ])
              }),
              0
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }